import { render } from "./Loans.vue?vue&type=template&id=5ecb3d98&scoped=true"
import script from "./Loans.vue?vue&type=script&lang=js"
export * from "./Loans.vue?vue&type=script&lang=js"

import "./Loans.vue?vue&type=style&index=0&id=5ecb3d98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecb3d98"]])

export default __exports__